import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"clearable":_vm.clearable,"items":_vm.options,"item-value":"id","label":_vm.$t('pages.surveyerSelect'),"item-text":_vm.userName,"multiple":_vm.multiple},model:{value:(_vm.surveyor),callback:function ($$v) {_vm.surveyor=$$v},expression:"surveyor"}})}
var staticRenderFns = []

export { render, staticRenderFns }